export interface Environment {
  context: EnvironmentContext;
  name: string;
  production: boolean;
  productsUrls: EnvironmentProductsUrls;
  config: Record<string, any>;
  clientConfig: Record<string, any>;
}

export type EnvironmentContext =
  | 'local'
  | 'develop'
  | 'staging'
  | 'production'
  | 'local-backend';

export type EnvironmentTisaProduct =
  | 'auth'
  | 'umpire'
  | 'wicket'
  | 'brisk'
  | 'gateway'
  | 'wicket-admin'
  | 'umpire-ott-client'
  | 'umpire-ott-tizen-client'
  | 'umpire-client';

export type EnvironmentProductsUrls = {
  [key in EnvironmentTisaProduct]?: string;
};
